import React, { useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Dialog } from "@headlessui/react";
import { Bars3Icon, XMarkIcon, UserIcon } from "@heroicons/react/24/outline";
import { useEffect, useState, Fragment } from "react";
import { UserContext } from '../../providers/UserProvider';

const navigation = [
  { name: "Үндсэн ээлж", href: "/eelj" },
  { name: "Мэдээ", href: "/news" },
  { name: "Хөтөлбөр", href: "/program" },
  { name: "Эцэг эхийн булан", href: "/parent" },
  { name: "Бидний тухай", href: "/about" },
  { name: "Ил тод байдал", href: "/transparency" },
];

const Header = (props: any) => {
  const {userBio, handleLogout} = useContext(UserContext);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const nav = useNavigate();

  useEffect(() => {
    setMenuOpen(false);
  }, [userBio]);

  return (
    <div className="bg-white fixed w-screen z-10">
      <div
        className="mx-auto flex max-w-7xl items-center justify-between gap-x-2 p-6 lg:px-8"
        aria-label="Global"
      >
        <div className="flex lg:flex-1">
          <div className="-m-1.5 p-1.5 cursor-pointer">
            <Link to="/">
              <img
                src="/logo.png"
                alt=""
                height={50}
                width={60}
              />
            </Link>
          </div>
        </div>
        <div className="flex items-center lg:hidden">
          <div className="flex items-center cursor-pointer" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
            {!localStorage.getItem('token') &&
              <Link to={'/login'}>
                  <button className="rounded-full bg-[#07B2EC] px-6 py-2 text-sm font-semibold text-white mr-4"
                    onClick={() => {setMobileMenuOpen(false);}}
                    >
                    Нэвтрэх
                  </button>
              </Link>
            }
            <button
              type="button"
              className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
            >
              <span className="sr-only" />
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                aria-hidden="true"
                className="h-6 w-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
                />
              </svg>
            </button>
            Цэс
          </div>
        </div>
        <div className="hidden lg:flex lg:gap-x-12">
          {navigation.map((item) => (
            <Link
              key={item.name}
              to={item.href}
              className="text-md font-semibold leading-6 text-[#001447]"
            >
              {item.name}
            </Link>
          ))}
          <a
            target="blank"
            href="https://old.nairamdal.mn/360nairamdal/index.html"
            className="text-md font-semibold leading-6 text-[#001447]"
          >
            360°
          </a>
        </div>
        <div className="hidden lg:flex flex-1 items-center justify-end gap-x-6">
          {userBio || localStorage.getItem('token') ? 
            <div className="hidden lg:flex flex-1 items-center justify-end gap-x-6" onClick={() => {setMenuOpen(!menuOpen)}}>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" aria-hidden="true" className="rounded-full bg-[#07B2EC] text-sm font-semibold text-white h-8 p-1 cursor-pointer">
                <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z"></path>
              </svg>
            </div>
            :
            <Link to={'/login'}>
                <button
                  className="rounded-full bg-[#07B2EC] px-6 py-2 text-sm font-semibold text-white mr-4"
                  >
                  Нэвтрэх
                </button>
            </Link>
          }
        </div>
      </div>
      <div aria-live="assertive" className="pointer-events-none fixed w-screen inset-0 flex items-end px-4 py-6 sm:items-start sm:p-6 z-20">
        {(userBio || localStorage.getItem('token')) && menuOpen &&
          <div className="flex w-full flex-col items-center space-y-4 sm:items-end mt-16 max-w-7xl mx-auto">
            <div className="pointer-events-auto w-full max-w-sm rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5 mr-10">
              <div className="p-4">
                <div className="flex-1">
                  <div className="ml-4 flex-col flex-shrink-0">
                    <Link to={`/profile`}>
                      <button type="button" onClick={() => {setMenuOpen(false);}} className="w-full inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
                        <span className="sr-only"></span>Хувийн мэдээлэл
                      </button>
                    </Link>
                    <div className="h-1 border-t-[1px] mt-2 mb-1">
                    </div>
                    {userBio?.role === 'teacher' &&
                      <>
                        <Link to={`/grouplist`}>
                          <button type="button" onClick={() => {setMenuOpen(false);}} className="w-full inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
                            <span className="sr-only"></span>Бүлгийн хүүхдүүдийг харах
                          </button>
                        </Link>
                        <div className="h-1 border-t-[1px] mt-2 mb-1"/>
                      </>
                    }
                    <button type="button" onClick={() => {handleLogout(); nav('/');}} className="w-full inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
                      <span className="sr-only"></span>Гарах
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
      {mobileMenuOpen &&
        <div>
          <Dialog
            as="div"
            className="lg:hidden"
            open={mobileMenuOpen}
            onClose={setMobileMenuOpen}
          >
            <div className="fixed inset-0 z-10" />
              <Dialog.Panel className="fixed inset-y-0 right-0 z-10 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
                <div className="flex items-center justify-between gap-x-2">
                  <Link to="/" className=" cursor-pointer">
                    <img
                      src="/nairamdal_logo_new.png"
                      height={50}
                      width={130}
                      alt=""
                      onClick={() => {setMobileMenuOpen(false);}}
                    />
                  </Link>
                  <div className="flex items-center justify-end">
                    <button
                      type="button"
                      className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      <span className="sr-only"></span>
                      <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                    </button>
                  </div>
                </div>
                <div className="mt-6 flow-root">
                  <div className="-my-6 divide-y divide-gray-500/10">
                    <div className="space-y-2 py-6">
                      {userBio ? 
                        <div>
                          <div className="lg:flex flex-1 items-center justify-end gap-x-6">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" aria-hidden="true" className="rounded-full bg-[#07B2EC] text-sm font-semibold text-white h-8 p-1 cursor-pointer">
                              <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z"></path>
                            </svg>
                          </div>
                          <div className="h-1 border-t-[1px] mt-2 mb-1" />
                          <Link to={`/profile/${userBio?.id}`}>
                            <button type="button" onClick={() => {setMobileMenuOpen(false);}} className="w-full inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
                              <span className="sr-only"></span>Хувийн мэдээлэл
                            </button>
                          </Link>
                          <div className="h-1 border-t-[1px] mt-2 mb-1">
                          </div>
                          {userBio?.role === 'teacher' &&
                            <>
                              <Link to={`/grouplist`}>
                                <button type="button" onClick={() => {setMenuOpen(false);}} className="w-full inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
                                  <span className="sr-only"></span>Бүлгийн хүүхдүүдийг харах
                                </button>
                              </Link>
                              <div className="h-1 border-t-[1px] mt-2 mb-1"/>
                            </>
                          }
                          <button type="button" onClick={() => {setMobileMenuOpen(false); handleLogout(); nav('/');}} className="w-full inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
                            <span className="sr-only"></span>Гарах
                          </button>

                        </div>
                        :
                        <Link to={'/login'}>
                            <button className="rounded-full bg-[#07B2EC] px-6 py-2 text-sm font-semibold text-white mr-4"
                              onClick={() => {setMobileMenuOpen(false);}}
                              >
                              Нэвтрэх
                            </button>
                        </Link>
                      }

                      {navigation.map((item) => (
                        <Link
                          key={item.name}
                          to={item.href}
                          onClick={() => setMobileMenuOpen(false)}
                          className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-[#001447] hover:bg-gray-50"
                        >
                          {item.name}
                        </Link>
                      ))}
                      <a
                        target="blank"
                        href="https://nairamdal.mn/360nairamdal/index.html"
                        className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-[#001447] hover:bg-gray-50"
                      >
                        360°
                      </a>
                    </div>
                  </div>
                </div>
              </Dialog.Panel>
          </Dialog>
        </div>
      }
    </div>
  );
};

export default Header;